export default __webpack_public_path__ + "static/media/documentPdf.aaa57f44.svg";